import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ADMIN_ACCOUNT_API, getImageUrl } from "../config/api";
import "../styles/AdminNavbar.css";

function AdminNavbar({ toggleSidebar }) {
  const adminId = localStorage.getItem("adminId") || "";
  const [adminName, setAdminName] = useState(localStorage.getItem("adminName") || "Admin");
  const [adminEmail, setAdminEmail] = useState(localStorage.getItem("adminEmail") || "");
  const [profilePic, setProfilePic] = useState(localStorage.getItem("adminProfilePic") || "");

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/admin/login";
  };
  useEffect(() => {
    const fetchAdminDetails = async () => {
      if (!adminId) return;
      try {
        const res = await fetch(ADMIN_ACCOUNT_API, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: Number(adminId) })
        });
        const data = await res.json();
        if (data.status === "success" && data.admin) {
          setAdminName(data.admin.name || "Admin");
          setAdminEmail(data.admin.email || "");
          setProfilePic(data.admin.profile_pic || "");
          localStorage.setItem("adminName", data.admin.name || "Admin");
          localStorage.setItem("adminEmail", data.admin.email || "");
          localStorage.setItem("adminProfilePic", data.admin.profile_pic || "");
        }
      } catch (err) {
        console.error("Failed to load navbar admin profile", err);
      }
    };

    fetchAdminDetails();

    window.addEventListener("adminProfileUpdated", fetchAdminDetails);
    return () => {
      window.removeEventListener("adminProfileUpdated", fetchAdminDetails);
    };
  }, [adminId]);
  const DEFAULT_AVATAR = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><circle cx="20" cy="20" r="20" fill="%2358181f"/><path d="M20 11a5 5 0 100 10 5 5 0 000-10zm-7 19c0-3.5 3.5-6 7-6s7 2.5 7 6" fill="none" stroke="%23bc9341" stroke-width="2.5" stroke-linecap="round"/></svg>`;

  const getAvatarUrl = () => {
    return getImageUrl(profilePic, DEFAULT_AVATAR);
  };

  return (
    <nav className="admin-navbar">
      <div className="navbar-left">
        {/* Toggle button visible only on mobile/tablet */}
        <button
          type="button"
          className="navbar-toggle-btn"
          onClick={toggleSidebar}
          aria-label="Toggle sidebar menu"
        >
          <i className="bi bi-list"></i>
        </button>

        {/* Brand Title */}
        <Link to="/admin/home" className="navbar-brand">
          <span className="gold-accent">VaithikaSri</span> Admin Panel
        </Link>
      </div>

      <div className="navbar-right">
        {/* Profile Badge */}
        <div className="admin-profile-badge">
          <img
            src={getAvatarUrl()}
            alt="admin avatar"
            className="navbar-avatar"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = DEFAULT_AVATAR;
            }}
          />
          <div className="admin-profile-info">
            <span className="admin-profile-name">{adminName}</span>
            <span className="admin-profile-id">{adminEmail || `ID: #${adminId}`}</span>
          </div>
        </div>

        {/* Logout Button */}
        <button
          type="button"
          className="navbar-logout-btn"
          onClick={handleLogout}
          title="Sign Out of Panel"
        >
          <i className="bi bi-box-arrow-right"></i>
          <span>Logout</span>
        </button>
      </div>
    </nav>
  );
}

export default AdminNavbar;

